export default __webpack_public_path__ + "static/media/img_employee_tip4.2ce4a728.png";